var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpcomingWorksEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4997 0C20.5432 0 22.2001 1.65629 22.2001 3.69981V7.39962H51.7992V3.69981C51.7992 1.65629 53.4562 0 55.4997 0C57.5432 0 59.1995 1.65629 59.1995 3.69981V7.39962H62.8993C69.0303 7.39962 73.9994 12.3693 73.9994 18.4997V40.6998C73.9994 42.7433 72.3431 44.4003 70.2996 44.4003H48.0994C39.9255 44.4003 33.2996 51.0262 33.2996 59.2001V70.3002C33.2996 72.3437 31.6426 74 29.5991 74H11.1001C4.96966 74 0 69.031 0 62.8999V18.4997C0 12.3693 4.96966 7.39962 11.1001 7.39962H14.7999V3.69981C14.7999 1.65629 16.4562 0 18.4997 0Z",
    fill: "#949394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.787 58.1154C40.3418 56.6709 40.3418 54.3282 41.787 52.8831C43.2321 51.4381 45.5748 51.438 47.0192 52.8831L54.4195 60.2834C55.8646 61.7279 55.8646 64.0706 54.4195 65.5156L47.0192 72.9159C45.5747 74.3604 43.232 74.3604 41.787 72.9159C40.3418 71.4708 40.3418 69.1281 41.787 67.683L46.5708 62.8992L41.787 58.1154Z",
    fill: "#949394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.287 58.1154C58.8418 56.6709 58.8418 54.3282 60.287 52.8832C61.7315 51.438 64.0741 51.438 65.5192 52.8832L72.9195 60.2834C74.364 61.7279 74.364 64.0706 72.9195 65.5157L65.5192 72.9159C64.0741 74.3604 61.7314 74.3604 60.287 72.9159C58.8418 71.4708 58.8418 69.1281 60.287 67.683L65.0708 62.8992L60.287 58.1154Z",
    fill: "#949394"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingWorksEmpty);
export default __webpack_public_path__ + "static/media/upcoming-works-empty.1ba6f60352b816037c700b2d476ffcc5.svg";
export { ForwardRef as ReactComponent };